/**
 * External Dependencies
 */

import { router } from 'js-dom-router';
import 'jquery';
import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';
import 'modaal/dist/js/modaal';
import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { createPopper } from '@popperjs/core';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill(); // Smooth scroll for Safari as it's not supported nowadays
gsap.registerPlugin(ScrollTrigger);

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer

Default string of IE 10:
Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)

Default string of IE 11:
Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko

Default string of IE 12 (aka Edge):
Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0

Default string of Edge 13 (thx @DrCord):
Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586

Default string of Edge 14:
Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/14.14300

Test at CodePen:
http://codepen.io/gapcode/pen/vEJNZN
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }
  /* //De momento no tenemos ningún problema con Edge...
  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
     // Edge (IE 12+) => return version number
     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  */
  // other browser
  return false;
}

jQuery(function() {

  var ie_browser = detectIE();
  if (ie_browser !== false) {
    document.documentElement.className += ' fonts-loaded ie ie' + ie_browser;
  } else {
    // fontfaceobserver para evitar FOIT
    // https://fontfaceobserver.com/
    // https://jonsuh.com/blog/font-loading-with-font-events/

    var primaryFont = new FontFaceObserver('neue-haas-grotesk-display');

    Promise.all([
      primaryFont.load(),
    ]).then(function () {
      $(document.documentElement).addClass('fonts-loaded');
    });
  }

  var $body = $('body');

  // Full Menu Primary
  $('.primary-menu-trigger').on('click', function (e) {
    e.preventDefault();
    $body.toggleClass('full-menu-primary-active');
  });

  $('.shop-menu-trigger').on('click', function (e) {
    e.preventDefault();
    $body.toggleClass('full-menu-shop-active');
  });

  $('.full-search-trigger').on('click', function (e) {
    e.preventDefault();
    $('.full-search').addClass('full-search--' + $(this).data('type'));
    $body.toggleClass('full-search-active');
  });

  $('.menu-close').on('click', function (e) {
    e.preventDefault();
    $body.removeClass('full-menu-primary-active');
    $body.removeClass('full-menu-shop-active');
    $body.removeClass('full-search-active');
    setTimeout( () => {
      $('.full-search').removeClass('full-search--post full-search--product');
    }, 400);
  });

  // User profile Modaal
  $('.user-popup-trigger').modaal({
    custom_class : 'user-popup',
  });

  // Video popup Modaal
  $('.video-popup').modaal({
    type: 'video',
  });

  // Allow multiple instances in the same page
  var category_slider_mini_instances = {},
      $category_slider_mini_containers = $('.category-slider-mini-container');
  if ($category_slider_mini_containers.length > 0) {
    let spaceBetween = 15,
      slidesOffsetAfter = 15;
    // if (window.innerWidth > 576) { //$screen-sm-min
    //   spaceBetween = 50;
    //   slidesOffsetAfter = 50;
    // }

    $category_slider_mini_containers.each(function(index){
      var $this = $(this);
      $this.addClass('category-slider-mini-instance-' + index);
      $this.siblings('.category-slider-mini-button-prev').eq(0).addClass('category-slider-mini-button-prev-' + index);
      $this.siblings('.category-slider-mini-button-next').eq(0).addClass('category-slider-mini-button-next-' + index);
      var loop = !!$this.data('loop'); // Convert integer to boolean
      category_slider_mini_instances[index] = new Swiper('.category-slider-mini-instance-' + index, {
        slidesPerView: 'auto',
        loop: loop,
        spaceBetween: spaceBetween,
        effect: 'slide',
        slidesOffsetAfter: slidesOffsetAfter,
        freeMode: true,
        freeModeSticky: true,
        navigation: {
          nextEl: '.category-slider-mini-button-next-' + index,
          prevEl: '.category-slider-mini-button-prev-' + index,
        },
      });
    });
  }

  $(document).on('click', '.dismiss', function(e){
    e.preventDefault();
    $(this).parent().remove();
  });

  // Copy to clipboard function
  function copy(e) {
    const link = e.currentTarget;
    let input = null;
    for (var i = 0; i < link.childNodes.length; i++) {
        if (link.childNodes[i].className == 'clipboard-value') {
          input = link.childNodes[i];
          break;
        }
    }

    input.select();
    document.execCommand("copy");
  }

  // Init copy-to-clipboard links
  // var $clipboard_links = $('.clipboard-link');
  // if( $clipboard_links.length > 0 ){
  //   $clipboard_links.each(function(){
  //     const $link = $(this),
  //           $tooltip = $link.find('.tooltip'),
  //           link = $link[0],
  //           tooltip = $tooltip[0];

  //     const popperInstance = createPopper(link, tooltip);

  //     $link.on('click', function(e){
  //       e.preventDefault();
  //       copy(e);

  //       // Enable the event listeners for the tooltip
  //       popperInstance.setOptions({
  //         modifiers: [
  //           { name: 'eventListeners', enabled: true },
  //           { name: 'offset', options: { offset: [10, 3] } },
  //         ],
  //       });

  //       tooltip.setAttribute('data-show', '');
  //       popperInstance.update();

  //       // Hide tooltip 1s after shown
  //       setTimeout(function(){
  //         tooltip.removeAttribute('data-show');
  //         popperInstance.setOptions({
  //           modifiers: [{ name: 'eventListeners', enabled: false }],
  //         });
  //       }, 1000);
  //     });
  //   });
  // }

  $(document).on('click', '.enroll-link', function(){
    $(this).find('.spinner-border').show();
  });

  $(document).on('click', '.clipboard-link', function(e){
    e.preventDefault();

    const $link = $(this),
            $tooltip = $link.find('.tooltip'),
            link = $link[0],
            tooltip = $tooltip[0];

    const popperInstance = createPopper(link, tooltip);

    copy(e);

    // Enable the event listeners for the tooltip
    popperInstance.setOptions({
      modifiers: [
        { name: 'eventListeners', enabled: true },
        { name: 'offset', options: { offset: [10, 3] } },
      ],
    });

    tooltip.setAttribute('data-show', '');
    popperInstance.update();

    // Hide tooltip 1s after shown
    setTimeout(function(){
      tooltip.removeAttribute('data-show');
      popperInstance.setOptions({
        modifiers: [{ name: 'eventListeners', enabled: false }],
      });
    }, 1000);

  });


  // Init hover tooltip links
  var $has_hover_tooltip = $('.has-hover-tooltip');
  if( $has_hover_tooltip.length > 0 ){
    $has_hover_tooltip.each(function(){
      const $link = $(this),
            $tooltip = $link.find('.tooltip'),
            link = $link[0],
            tooltip = $tooltip[0];

      const popperInstance = createPopper(link, tooltip,{
        placement: 'top',
        modifiers: [
          { name: 'eventListeners', enabled: false },
        ],
      });

      function show(){
        // Enable the event listeners for the tooltip
        popperInstance.setOptions({
          modifiers: [
            { name: 'eventListeners', enabled: true },
            { name: 'offset', options: { offset: [0, -20] } },
          ],
        });

        tooltip.setAttribute('data-show', '');
      }

      function hide(){
        // Hide the tooltip
        tooltip.removeAttribute('data-show');

        // Disable the event listeners
        popperInstance.setOptions({
          modifiers: [{ name: 'eventListeners', enabled: false }],
        });
      }

      $link.on({
        mouseenter: show,
        mouseleave: hide,
        focus: show,
        blur: hide,
      });
    });
  }

  if (window.innerWidth < 768) {
    // Mobile Sticky header
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById('mobile-sticky-header');

    var checkScroll = function() {

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }

      prevScroll = curScroll;

      if( curScroll < 200 ){
        header.classList.remove('visible');
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }
    };

    var toggleHeader = function(direction, curScroll) {
      if (direction === 2) {
        header.classList.remove('visible');
        prevDirection = direction;
      }

      if (direction === 1 && curScroll > 200) {
        header.classList.add('visible');
        prevDirection = direction;
      }
    };

    window.addEventListener('scroll', checkScroll);
  }

});

// Courses landing JS
import courses_landing from './routes/courses-landing';
import checkout from './routes/checkout';
import single_product from './routes/single-product';
import partner_account from './routes/partner-account';
import affiliate_account from './routes/affiliate-account';
// import cart from './routes/cart';

/**
 * Set up DOM router
 *
 * .on(<name of body class>, callback)
 *
 * See: {@link http://goo.gl/EUTi53 | Markup-based Unobtrusive Comprehensive DOM-ready Execution} by Paul Irish
 */
router
  .on('courses-landing', courses_landing)
  .on('woocommerce-checkout', checkout)
  .on('single-product', single_product)
  .on('partner-account', partner_account)
  .on('affiliate-account', affiliate_account)
  // .on('woocommerce-cart', cart)
  .ready();
